import { Component } from "react";
import "./SpinnerDialog.css";
import PropTypes from "prop-types";
import Dialog from "./components/Dialog/Dialog";
import TalaeraSpinner from "./../TalaeraSpinner/TalaeraSpinner";

/**
 * The modal window with spinner inside.
 */
export default class SpinnerDialog extends Component {
  render() {
    return (
      <Dialog
        showDialog={this.props.showDialog}
        onClose={this.props.onClose}
        closeOnOuterClick={this.props.closeOnOuterClick}
        className={"spinner-dialog " + this.props.className}
      >
        <TalaeraSpinner className="spinner" />
      </Dialog>
    );
  }
}

SpinnerDialog.propTypes = {
  /** Boolean value that defines whether to show dialog or not. */
  showDialog: PropTypes.bool.isRequired,
  /** Boolean value that defines whether to close the dialog if someone clicks outside of the modal window. */
  closeOnOuterClick: PropTypes.bool,
  /** A custom CSS class name that can be added to the dialog's default list of classes. */
  className: PropTypes.string,
  /** Function/callback that invokes when dialog is being closed. */
  onClose: PropTypes.func.isRequired,
};
